import React from 'react';
import 'react-table/react-table.css';
import { Redirect } from 'react-router-dom';
import $ from 'jquery';
import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import 'bootstrap-datepicker/js/bootstrap-datepicker.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import { AdminUrls } from '../../network/config';
import { removeData } from '../../store/action';
import { connect } from 'react-redux';
import Select from 'react-select';

const moment = require('moment');

const MAX_DATE = new Date();
let default_date_completed = '';

const getCourse_Url = AdminUrls.COMMON.GETCOURSESBYCPDTYPE;
const updateMember_Url = AdminUrls.USER.WORKFLOWUPDATE;
const addMember_Url = AdminUrls.USER.WORKFLOWADD;
const fileUpload_Url = AdminUrls.USER.FILEUPLOAD;

//On view load: Call member info, types, formats, hosts, locations api. Fill data for first step automatically
class FormCPD extends React.Component {
  constructor(props) {
    super(props);
    const {
      match: { params },
    } = this.props;

    this.state = {
      mode: params.mode,
      workFlowId: params.workFlowId,
      currentStep: 1,
      host_list: [],
      member_info: [],
      types: [],
      formats: [],
      locations: [],
      courses: [],
      uid: '',
      cpd_type_id: 1,
      MemberId: null,
      course_company: '',
      course_format: 'Online',
      course_id: '',
      course_name: '',
      course_detail: [],
      course_description: '',
      venue: '',
      cpd_hours: '',
      cpd_mins: 0,
      cpd_year: new Date().getFullYear(),
      date_completed: null,
      start_date_iso: '',
      file_upload: null,
      file_name: null,
      host_id: '',
      trainer: '',
      location_id: '',
      is_declared: false,
      third_tab_active: false,
      unauthorized: false,
      redirectDashboard: false,
      member_id: '',
    };
    this.controller = new AbortController();
    this.handlePrevStep = this.handlePrevStep.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleNextStep = this.handleNextStep.bind(this);
    this.handleSaveRecord = this.handleSaveRecord.bind(this);
    this.fetchMemberInfo = this.fetchMemberInfo.bind(this);
    this.fetchTypes = this.fetchTypes.bind(this);
    this.fetchFormats = this.fetchFormats.bind(this);
    this.fetchHosts = this.fetchHosts.bind(this);
    this.fetchLocations = this.fetchLocations.bind(this);
    this.fetchCourses = this.fetchCourses.bind(this);
    this.fetchCourseDetail = this.fetchCourseDetail.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.fetchCPDRecord = this.fetchCPDRecord.bind(this);
    this.makeThirdTabActive = this.makeThirdTabActive.bind(this);
  }

  componentDidMount() {
    $('.datepicker').datepicker({
      autoclose: true,
      todayHighlight: true,
      maxDate: new Date(),
    });

    let dataMember = this.props.location.state;
    let id_u = this.props.match?.params?.workFlowId;

    if (this.state.mode === 'edit' || this.state.mode === 'view') {
      if (dataMember) {
        this.setState(
          {
            member_id: this.props?.location?.state?.UserId,
            workFlowId: dataMember?.CPDWorkflowId,
            course_format: dataMember?.CPDFormatId,
            course_company: dataMember?.Company,
            uid: dataMember?.UserId,
            cpd_type_id: dataMember?.CPDTypeId,
            course_description: dataMember?.CourseDescription,
            venue: dataMember?.Venue,
            cpd_hours: dataMember?.Hours,
            cpd_mins: dataMember?.Minutes,
            cpd_year: dataMember?.CPDYear,
            file_name: dataMember?.FileName,
            host_id: dataMember?.HostId,
            trainer: dataMember?.Trainer,
            location_id: dataMember?.LocationId,
            course_id: dataMember?.CourseId,
            course_name: dataMember?.CourseName,
            start_date_iso: dataMember?.CompletionDate,
            is_declared: dataMember?.IsDeclared,
            date_completed: dataMember?.CompletionDate.split('T')[0],
          },
          () => {
            this.makeThirdTabActive();
            this.fetchTypes();
            this.fetchFormats();
            this.fetchHosts();
            this.fetchLocations();
            this.fetchCourses();
            this.fetchMemberInfo(dataMember?.UserId);
            // this.fetchCPDRecord();
          }
        );
      }
    }
    if (this.state.mode === 'add') {
      this.setState({
        member_id: this.props?.location?.state?.UserId,
        UserId: this?.props?.location?.state?.Id,
      });
      this.fetchMemberInfo(id_u);
      this.fetchTypes();
      this.fetchFormats();
      this.fetchHosts();
      this.fetchLocations();
      this.fetchCourses();
    }
  }
  fetchTypes() {
    let self = this;
    axios
      .get(AdminUrls.USER.CPDTYPE, {
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        if (data) {
          self.setState({ types: data });
        }
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  fetchMemberInfo(memberId) {
    let self = this;
    axios
      .get(AdminUrls.USER.GETMEMBERINFO, {
        params: {
          memID: memberId,
        },
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        if (data) {
          self.setState({
            member_info: data,
            MemberId: data.MemberId,
          });
        }
      })
      .catch(function (error) {
        if (error) {
          if (error.response) {
            if (error.response.status === 401) {
              self.setState({
                unauthorized: true,
              });
            }
          }
        }
      });
  }

  fetchFormats() {
    let self = this;
    axios
      .get(AdminUrls.COMMON.CPDFORMAT, {
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        if (data) {
          self.setState({ formats: data });
        }
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  fetchHosts() {
    let self = this;
    // Hosts List
    axios
      .get(AdminUrls.COMMON.LOADHOST, {
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        if (data) {
          self.setState({ host_list: data });
        }
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  fetchLocations() {
    let self = this;
    axios
      .get(AdminUrls.COMMON.COURSELOCATION, {
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        if (data) {
          self.setState({ locations: data });
        }
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  fetchCourses(TypeId, checkStates) {
    let self = this;
    let cpd_type_id = this.state.cpd_type_id;
    if (TypeId) {
      cpd_type_id = TypeId;
    }

    if (checkStates !== 'edit' && TypeId != null) {
      this.setState({
        cpd_type_id: TypeId,
        course_format: 'Online',
        course_id: '',
        course_name: '',
        course_description: '',
        venue: '',
        cpd_hours: '',
        cpd_mins: 0,
        cpd_year: new Date().getFullYear(),
        date_completed: '',
        start_date_iso: '',
        file_upload: null,
        file_name: null,
        host_id: '',
        trainer: '',
        location_id: '',
        courses_option: [],
        selectedOptionCourses: null,
      });
    }

    axios
      .get(getCourse_Url, {
        params: {
          CPDTypeId: cpd_type_id,
        },
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        if (data.Items) {
          let courses_option = [];
          data.Items.map((item, key) =>
            courses_option.push({
              key: item.CourseId,
              value: item.CourseName,
              text: item.CourseName,
              // value: item.CourseId,
              label: item.CourseName,
            })
          );
          self.setState({
            courses: data.Items,
            courses_option: courses_option,
            selectedOptionCourses: {
              label: this.state.course_name,
              value: this.state.course_id,
            },
          });
        }
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  fetchCourseDetail(CourseId) {
    let self = this;
    let course_id = this.state.course_id;
    if (CourseId) {
      course_id = CourseId;
    }

    axios
      .get(AdminUrls.COMMON.GETCOURSEBYID, {
        params: {
          CourseId: course_id,
        },
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        if (data) {
          self.setState({
            course_detail: data,
            course_id: CourseId,
            course_name: data?.CourseName,
            course_format: data?.CPDFormatId,
            course_description: data?.CourseDescription,
            venue: data?.Venue,
            cpd_hours: data?.DurationHours,
            cpd_mins: data?.Minutes !== null ? data.Minutes : 0,
            cpd_year:
              data?.CPDYear !== null ? data.CPDYear : new Date().getFullYear(),
            trainer: data?.Trainer,
            host_id: data?.HostId,
            location_id: data?.LocationId,
            file_upload: null,
            file_name: null,
            course_company: data?.HostName,
          });

          this.makeThirdTabActive();
        }
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  handlePrevStep() {
    this.setState({
      currentStep: this.state.currentStep - 1,
    });
  }

  handleNextStep() {
    this.setState({
      currentStep: this.state.currentStep + 1,
    });
  }

  makeThirdTabActive() {
    if (this.state.cpd_type_id === '4') {
      if (
        this.state.cpd_type_id !== '' &&
        this.state.course_name !== '' &&
        this.state.course_format !== '' &&
        this.state.course_description !== '' &&
        this.state.venue !== '' &&
        this.state.cpd_hours !== '' &&
        this.state.file_name !== null &&
        this.state.date_completed !== ''
      ) {
        this.setState({
          third_tab_active: true,
        });
      } else {
        this.setState({
          third_tab_active: false,
        });
      }
    } else {
      if (
        this.state.cpd_type_id !== '' &&
        this.state.course_id !== '' &&
        this.state.course_description !== '' &&
        this.state.venue !== '' &&
        this.state.cpd_hours !== '' &&
        this.state.file_name !== null &&
        this.state.date_completed !== ''
      ) {
        this.setState({
          third_tab_active: true,
        });
      } else {
        this.setState({
          third_tab_active: false,
        });
      }
    }
  }

  handleSaveRecord() {
    if (this.state.mode === 'edit') {
      axios
        .post(
          updateMember_Url,
          {
            CPDFormatId: this.state.course_format,
            CPDTypeId: this.state.cpd_type_id,
            CPDWorkflowId: this.state.workFlowId,
            CPDYear: this.state.cpd_year,
            Company: this.state.course_company,
            CompletionDate: this.state.start_date_iso,
            CourseId: this.state.course_id,
            CourseMode: 1,
            CourseName: this.state.course_name,
            Description: this.state.course_description,
            FileName: this.state.file_name,
            HostId: this.state.host_id,
            HostName: this.state.course_company,
            Hours: +this.state.cpd_hours,
            IsDeclared: this.state.is_declared,
            LocationId: this.state.location_id,
            MemberId: this.state.MemberId,
            Minutes: this.state.cpd_mins,
            Trainer: this.state.trainer,
            Venue: this.state.venue,
          },
          {
            headers: {
              Authorization:
                `${this.props.user.token_type} ` + this.props.user.access_token,
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          }
        )
        .then((response) => response.data)
        .then((data) => {
          this.handleFileUpload(data);
          let obj = {
            Id: this.state.MemberId,
            uid: this.state.UserId ?? this.state.member_id,
          };
          this.props.history.push({
            pathname: `/my_cpd_report/${obj?.Id}/${obj?.uid}`,
            state: obj,
          });
        })
        .catch((error) => {
          if (error?.response?.status && error?.response?.status === 401) {
            this.props.signOut();
          }
        });
    } else {
      if (window.confirm('Are you sure you want to save?')) {
        var cpdyear = new Date().getFullYear();
        if (this.state.cpd_year) {
          cpdyear = this.state.cpd_year;
        }
        axios
          .post(
            addMember_Url,
            {
              CPDFormatId: +this.state.course_format,
              CPDTypeId: +this.state.cpd_type_id,
              CPDWorkflowId: 0,
              CPDYear: +cpdyear,
              Company: this.state.course_company,
              CompletionDate: this.state.start_date_iso,
              CourseId: +this.state.course_id,
              CourseMode: '',
              CourseName: this?.state?.course_name,
              Description: this.state.course_description,
              FileName: this.state.file_name,
              HostId: +this.state.host_id,
              HostName: this.state.course_company,
              Hours: +this.state.cpd_hours,
              IsDeclared: this.state.is_declared,
              LocationId: +this.state.location_id,
              MemberId: this.state.MemberId,
              Minutes: this.state.cpd_mins,
              Trainer: this.state.trainer,
              Venue: this.state.venue,
            },
            {
              headers: {
                Authorization:
                  `${this.props.user.token_type} ` +
                  this.props.user.access_token,
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
              },
            }
          )
          .then((response) => response?.data)
          .then((data) => {
            this.handleFileUpload(data);
            let obj = {
              Id: this.state.MemberId,
              uid: this.state.member_id,
            };
            this.props.history.push({
              pathname: `/my_cpd_report/${obj?.Id}/${
                obj?.uid ?? this.state.workFlowId
              }`, // need to review this
              state: obj,
            });
          })
          .catch((error) => {
            NotificationManager.error(error.response?.data);
            if (error?.response?.status && error?.response?.status === 401) {
              this.props.signOut();
            }
          });
      }
    }

    // this.props.history.push("/home");
  }

  handleFileUpload(record) {
    let blobFile = this.state.file_upload;
    let formData = new FormData();
    formData.append('file', blobFile);

    axios
      .post(fileUpload_Url, formData, {
        processData: false,
        contentType: false,
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',

          workflowreqid: record.CPDWorkflowId,
        },
      })
      .then((response) => response.data)
      .then((data) => {
        NotificationManager.success(
          'Success!',
          'MyCPD Record Created Successfully'
        );
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  handleCourseNameChange(selectedOption) {
    this.setState({ selectedOption }, () =>
      console.log(`Option selected:`, this.state.selectedOption)
    );
  }

  handleChangeDropdown = (e) => {
    this.setState({
      course_name: e.label,
      course_id: e.key,
      selectedOptionCourses: e,
    });
    this.fetchCourseDetail(e.key);
  };

  handleInputChange(event, field_name) {
    if (field_name === 'date_completed') {
      let newValue = new Date(event?.target?.value).toISOString();
      default_date_completed = '';

      // var mydate = moment(newValue, "DD/MM/YYYY");
      // let newDate = new Date(moment(mydate).format("MM/DD/YYYY"));
      // newValue = newDate.toISOString();

      this.setState({
        start_date_iso: newValue,
        date_completed: event?.target?.value,
      });
    } else {
      var value = '';
      var name = '';
      const target = event.target;
      if (target && target.value) {
        value = target.value;
      }
      if (target && target.name) {
        name = target.name;
      }

      if (name === 'file_upload') {
        if (event.target.files.length > 0) {
          this.setState({
            [name]: event.target.files[0],
            file_name: event.target.files[0].name,
          });
        }
      } else if (name === 'is_declared') {
        this.setState({
          is_declared: target.checked,
        });
      } else {
        this.setState({
          [name]: value,
        });
      }

      if (name === 'cpd_type_id') {
        this.fetchCourses(value);
      }

      if (name === 'course_id') {
        this.fetchCourseDetail(value);
      }
    }

    setTimeout(() => {
      this.makeThirdTabActive();
    }, 500);
  }

  fetchCPDRecord() {
    let self = this;

    axios
      .get(AdminUrls.USER.MEMBERCPD, {
        params: {
          page: 1,
          pageSize: 10,
          reverse: true,
          sortBy: 'CPDWorkflowId',
          limit: this.state.workFlowId,
        },
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        if (data.Items) {
          data.Items.forEach((element) => {
            default_date_completed = moment(element.CompletionDate)
              .format('DD/MM/YYYY')
              .toString();
            if (element.CPDWorkflowId === self.state.workFlowId) {
              self.setState({
                cpd_type_id: element.CPDTypeId,
                course_format: element.CPDFormatId,
                course_id: element.CourseId,
                course_name: element.CourseName,
                course_description: element.CourseDescription,
                venue: element.Venue,
                cpd_hours: element.Hours,
                cpd_mins: element.Minutes ? element.Minutes : 0,
                cpd_year: element.CPDYear ? element.CPDYear : 2025,
                date_completed: element.CompletionDate,
                start_date_iso: element.CompletionDate,
                file_name: element.FileName,
                host_id: element.HostId,
                trainer: element.Trainer,
                location_id: element.LocationId,
                is_declared: element.IsDeclared,
              });
              this.fetchCourses(element.CPDTypeId, 'edit');
              setTimeout(() => {
                this.makeThirdTabActive();
              }, 500);
            }
          });
        }
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }
  componentWillUnmount() {
    this.controller.abort();
  }

  render() {
    if (this.state.unauthorized) {
      return <Redirect to="/" />;
    }

    if (this.state.redirectDashboard) {
      return <Redirect to="/recordcpd" />;
    }

    let ListItemOne,
      ListItemTwo,
      ListItemThree,
      currentActiveClass,
      nextTabClass,
      prevTabClass;
    currentActiveClass = 'current';
    prevTabClass = 'done';
    nextTabClass = 'default';

    if (this.state.mode === 'edit') {
      currentActiveClass = 'editing';
      nextTabClass = 'done';
    }

    if (this.state.currentStep === 1) {
      ListItemOne = (
        <li className={currentActiveClass}>
          <a>Submitter Details</a>
        </li>
      );
      ListItemTwo = (
        <li className={nextTabClass}>
          <a>Confirm CPD Activity Details</a>
        </li>
      );
      ListItemThree = (
        <li className={nextTabClass}>
          <a>CPD Details</a>
        </li>
      );
    } else if (this.state.currentStep === 2) {
      ListItemOne = (
        <li className={prevTabClass}>
          <a onClick={() => this.setState({ currentStep: 1 })} href="#">
            Submitter Details
          </a>
        </li>
      );
      ListItemTwo = (
        <li className={currentActiveClass}>
          <a>Confirm CPD Activity Details</a>
        </li>
      );
      ListItemThree = (
        <li className={nextTabClass}>
          <a>CPD Details</a>
        </li>
      );
    } else if (this.state.currentStep === 3) {
      ListItemOne = (
        <li className={prevTabClass}>
          <a onClick={() => this.setState({ currentStep: 1 })} href="#">
            Submitter Details
          </a>
        </li>
      );
      ListItemTwo = (
        <li className={prevTabClass}>
          <a onClick={() => this.setState({ currentStep: 2 })} href="#">
            Confirm CPD Activity Details
          </a>
        </li>
      );
      ListItemThree = (
        <li className={currentActiveClass}>
          <a>CPD Details</a>
        </li>
      );
    }

    return (
      <div>
        {this?.state?.mode === 'edit' || this?.state?.mode === 'add' ? (
          <div>
            <ul className="steps-indicator steps-3">
              {ListItemOne}
              {ListItemTwo}
              {ListItemThree}
            </ul>
            <div className="steps ">
              <section
                className="step"
                style={{
                  display: this.state.currentStep === 1 ? 'block' : 'none',
                }}
              >
                <div className="panel panel-primary ">
                  <div className="panel-heading">Submitter Details</div>
                  <div className="container container-table">
                    <div className="row vertical-center-row" id="step-1">
                      <div style={{ marginTop: '40px' }}> </div>
                      <div className="col-md-6 col-md-offset-3">
                        <div className="form-group">
                          <label htmlFor="FirstName" className="control-label">
                            First Name
                          </label>
                          <input
                            type="text"
                            className="form-control "
                            placeholder="Enter First Name"
                            disabled="disabled"
                            id="FirstName"
                            name="FirstName"
                            value={this.state.member_info['FirstName']}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="Surname" className="control-label">
                            Last Name
                          </label>
                          <input
                            maxLength="100"
                            type="text"
                            className="form-control "
                            placeholder="Enter Last Name"
                            disabled="disabled"
                            id="Surname"
                            name="Surname"
                            readOnly
                            value={this.state.member_info['Surname']}
                            aria-invalid="false"
                          />
                        </div>
                        <div className="form-group">
                          <label
                            htmlFor="MemberNumber"
                            className="control-label"
                          >
                            Membership Number
                          </label>
                          <input
                            maxLength="100"
                            type="text"
                            className="form-control "
                            placeholder="Enter MembershipNumber"
                            disabled="disabled"
                            id="MemberNumber"
                            name="MemberNumber"
                            readOnly
                            value={this.state.member_info['MemberNumber']}
                            aria-invalid="false"
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="Email" className="control-label">
                            Email
                          </label>
                          <input
                            maxLength="100"
                            type="text"
                            className="form-control "
                            placeholder="Enter Email"
                            disabled="disabled"
                            id="Email"
                            name="Email"
                            readOnly
                            value={this.state.member_info['Email']}
                            aria-invalid="false"
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="Address" className="control-label">
                            Address
                          </label>
                          <textarea
                            required="required"
                            className="form-control"
                            disabled="disabled"
                            value={
                              this.state.member_info['Address']
                                ? this.state.member_info['Address']
                                : 'address'
                            }
                            placeholder="Enter your address"
                            rows="4"
                            id="Address"
                            name="Address"
                            readOnly
                            aria-invalid="false"
                          >
                            {' '}
                          </textarea>
                        </div>
                        <div>
                          <button
                            className="btn btn-primary pull-right"
                            onClick={this.handleNextStep}
                          >
                            Next step <i className="fa fa-arrow-right"> </i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section
                className="step"
                style={{
                  display: this.state.currentStep === 2 ? 'block' : 'none',
                }}
              >
                <div className="panel panel-primary ">
                  <div className="panel-heading">
                    Confirm CPD Activity Details
                  </div>
                  <div className="container container-table">
                    <div
                      className="row vertical-center-row ng-invalid ng-invalid-required "
                      id="step-2"
                    >
                      <div style={{ marginTop: '40px' }}> </div>
                      <div className="col-md-6 col-md-offset-3">
                        <div className="form-group required">
                          <label
                            className="control-label"
                            htmlFor="cpd_type_id"
                          >
                            CPD Type
                          </label>
                          <select
                            className="form-control"
                            name="cpd_type_id"
                            id="cpd_type_id"
                            value={this.state.cpd_type_id}
                            onChange={this.handleInputChange}
                            required=""
                            aria-invalid="true"
                          >
                            <option value="" defaultValue>
                              {' '}
                            </option>
                            {this.state.types.map((item, key) => (
                              <option key={key} value={item.CPDTypeId}>
                                {item.Description}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="form-group required" aria-hidden="true">
                          <label className="control-label" htmlFor="course_id">
                            Course Title
                          </label>
                          <div id="custom-search-input">
                            {this.state.cpd_type_id !== '4' ? (
                              <Select
                                name="course_id"
                                id="course_id"
                                value={this.state.selectedOptionCourses}
                                options={this.state.courses_option}
                                onChange={this.handleChangeDropdown}
                                aria-invalid="true"
                                // style={{
                                //   display:
                                //     this.state.cpd_type_id !== 4
                                //       ? "block"
                                //       : "none",
                                // }}
                              ></Select>
                            ) : (
                              <input
                                type="text"
                                className="form-control ng-empty ng-invalid ng-invalid-required-maxlength"
                                name="course_name"
                                id="course_name"
                                value={this.state.course_name}
                                onChange={this.handleInputChange}
                                placeholder="Course Title"
                                required=""
                                aria-invalid="true"
                              />
                            )}
                          </div>
                        </div>
                        <div className="form-group required">
                          <label htmlFor="cmbformat" className="control-label">
                            Format
                          </label>
                          <select
                            className="form-control"
                            name="course_format"
                            id="course_format"
                            value={this.state.course_format}
                            onChange={this.handleInputChange}
                            required=""
                            disabled={
                              this.state.cpd_type_id === '4' ? '' : 'disabled'
                            }
                            aria-invalid="true"
                          >
                            <option value="" defaultValue></option>
                            {this.state.formats.map((item, key) => (
                              <option
                                key={key}
                                value={item.ID}
                                label={item.Name}
                              >
                                {item.Name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="form-group required">
                          <label
                            className="control-label"
                            htmlFor="txtDescription"
                          >
                            Description
                          </label>
                          <textarea
                            className="form-control  ng-empty ng-invalid ng-invalid-required"
                            name="course_description"
                            id="course_description"
                            value={this.state.course_description}
                            onChange={this.handleInputChange}
                            rows="4"
                            required=""
                            aria-invalid="true"
                          ></textarea>
                          <span
                            id="helpText"
                            className="small ng-hide"
                            aria-hidden="true"
                          >
                            <em>
                              Please include a full course
                              description/outline/agenda. Submission will be
                              rejected if not enough detail to approve is
                              provided.
                            </em>
                          </span>
                        </div>
                        <div className="form-group required">
                          <label
                            htmlFor="intputVenue"
                            className="control-label"
                          >
                            Venue
                          </label>
                          <input
                            type="text"
                            className="form-control ng-empty ng-invalid ng-invalid-required-maxlength"
                            name="venue"
                            id="venue"
                            value={this.state.venue}
                            onChange={this.handleInputChange}
                            placeholder="Venue"
                            required=""
                            aria-invalid="true"
                          />
                        </div>
                        <div className="row">
                          <div className="form-group col-xs-4 col-md-4 required">
                            <label
                              className="control-label"
                              htmlFor="InputHour"
                            >
                              CPD Hours
                            </label>
                            <input
                              type="number"
                              className="form-control ng-empty ng-invalid ng-invalid-required"
                              id="cpd_hours"
                              name="cpd_hours"
                              value={this.state.cpd_hours}
                              onChange={this.handleInputChange}
                              placeholder="Hour"
                              step="1"
                              max="100"
                              min="0"
                              required=""
                              aria-invalid="true"
                            />
                          </div>
                          <div className="form-group col-xs-4 col-md-4">
                            <label className="control-label" htmlFor="InputMin">
                              Minutes
                            </label>
                            <input
                              type="number"
                              className="form-control ng-empty-step"
                              id="cpd_mins"
                              name="cpd_mins"
                              value={this.state.cpd_mins}
                              onChange={this.handleInputChange}
                              placeholder="Minute"
                              step="15"
                              max="45"
                              min="0"
                              aria-invalid="false"
                            />
                          </div>
                          <div className="form-group col-xs-4 col-md-4">
                            <label htmlFor="year" className="control-label">
                              CPD Year
                            </label>
                            <select
                              className="form-control "
                              id="cpd_year"
                              name="cpd_year"
                              value={this.state.cpd_year}
                              onChange={this.handleInputChange}
                              aria-invalid="false"
                            >
                              <option label="2022" value="2022">
                                2022
                              </option>
                              <option label="2023" value="2023">
                                2023
                              </option>
                              <option label="2024" defaultValue value="2024">
                                2024
                              </option>
                              <option label="2025" value="2025">
                                2025
                              </option>
                            </select>
                          </div>
                        </div>
                        <div className="form-group required">
                          <label className="control-label">
                            Date Completed
                          </label>
                          <input
                            id="date_completed"
                            label={
                              this.state.mode === 'edit'
                                ? default_date_completed
                                : 'Enter Completed Date'
                            }
                            type="date"
                            name="date_completed"
                            maxDate={MAX_DATE}
                            className="form-control"
                            locales="en-GB"
                            onChange={(value) => {
                              this.handleInputChange(value, 'date_completed');
                            }}
                            value={this.state.date_completed}
                          />
                        </div>
                        <div className="form-group required">
                          <label className="control-label">
                            Upload Evidence of Attendance
                          </label>
                          <div className="input-file ng-binding ">
                            {this.state.file_name && this.state.file_name}
                            <input
                              // value={this.state?.file_name}
                              id="file_upload"
                              type="file"
                              name="file_upload"
                              onChange={this.handleInputChange}
                              className="form-control"
                              required="required"
                              aria-invalid="true"
                            />
                            {/* <button className="icon-folder"> </button> */}
                          </div>
                        </div>
                        <div>
                          <button
                            className="btn btn-default"
                            name="previous"
                            onClick={this.handlePrevStep}
                            type="button"
                          >
                            <i className="fa fa-arrow-left"> </i> Previous step
                          </button>
                          <button
                            className="btn btn-primary pull-right"
                            type="button"
                            disabled={!this.state.third_tab_active}
                            onClick={this.handleNextStep}
                          >
                            Next step <i className="fa fa-arrow-right"> </i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section
                className="step"
                style={{
                  display: this.state.currentStep === 3 ? 'block' : 'none',
                }}
              >
                <div style={{ marginTop: '60px' }} className="ng-scope">
                  {' '}
                </div>
                <div className="panel panel-primary ng-scope">
                  <div className="panel-heading">CPD Details</div>
                  <div className="container container-table">
                    <div className="row vertical-center-row" id="step-3">
                      <div style={{ marginTop: '40px' }}> </div>
                      <div className="col-md-6 col-md-offset-3">
                        <div className="form-group required">
                          <label htmlFor="host" className="control-label">
                            Host
                          </label>
                          <select
                            name="host_id"
                            id="host_id"
                            value={this.state.host_id}
                            onChange={this.handleInputChange}
                            disabled={
                              this.state.cpd_type_id === '4' ? '' : 'disabled'
                            }
                            className="form-control ng-pristine ng-untouched ng-valid ng-not-empty"
                            aria-invalid="false"
                          >
                            <option value="" defaultValue>
                              {' '}
                            </option>
                            {this.state.host_list.map((item, key) => (
                              <option key={key} value={item.ID}>
                                {item.Name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="form-group">
                          <label className="control-label">Trainer</label>
                          <input
                            maxLength="200"
                            type="text"
                            required="required"
                            id="trainer"
                            name="trainer"
                            value={this.state.trainer ? this.state.trainer : ''}
                            onChange={this.handleInputChange}
                            disabled={
                              this.state.cpd_type_id === '4' ? '' : 'disabled'
                            }
                            className="form-control ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required ng-valid-maxlength"
                            placeholder="Trainer"
                            aria-invalid="true"
                          />
                        </div>

                        <div className="form-group required">
                          <label htmlFor="location" className="control-label">
                            Location
                          </label>
                          <select
                            name="location_id"
                            id="location_id"
                            value={this.state.location_id}
                            onChange={this.handleInputChange}
                            disabled={
                              this.state.cpd_type_id === '4' ? '' : 'disabled'
                            }
                            className="form-control ng-pristine ng-untouched ng-valid ng-not-empty"
                            aria-invalid="false"
                          >
                            <option value="" defaultValue>
                              {' '}
                            </option>
                            {this.state.locations.map((item, key) => (
                              <option key={key} value={item.ID}>
                                {item.Name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="form-group required">
                          <input
                            type="checkbox"
                            name="is_declared"
                            id="is_declared"
                            onChange={this.handleInputChange}
                            checked={this.state.is_declared}
                            value={this.state.is_declared}
                            style={{ float: 'left', margin: '3px 9px 0 0' }}
                            aria-invalid="false"
                          />
                          <label
                            htmlFor="is_declared"
                            style={{ overflow: 'hidden', display: 'block' }}
                          >
                            I declare this CPD is relevant to my role and in
                            accordance with the ATI CPD Guidelines and Rules.
                          </label>
                        </div>

                        <div style={{ marginBottom: '20px' }}>
                          <button
                            className="btn btn-default"
                            name="previous"
                            onClick={this.handlePrevStep}
                            type="button"
                          >
                            <i className="fa fa-arrow-left"> </i> Previous step
                          </button>
                          <button
                            className="btn btn-success pull-right"
                            type="button"
                            disabled={
                              this.state.is_declared === true ? '' : 'disabled'
                            }
                            value={this.state.is_declared}
                            onClick={this.handleSaveRecord}
                          >
                            <i className="fa fa-floppy-o"> </i> Save{' '}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        ) : (
          <div>
            <ul className="steps-indicator steps-3">
              {ListItemOne}
              {ListItemTwo}
              {ListItemThree}
            </ul>
            <div className="steps ">
              <section
                className="step"
                style={{
                  display: this.state.currentStep === 1 ? 'block' : 'none',
                }}
              >
                <div className="panel panel-primary ">
                  <div className="panel-heading">Submitter Details</div>
                  <div className="container container-table">
                    <div className="row vertical-center-row" id="step-1">
                      <div style={{ marginTop: '40px' }}> </div>
                      <div className="col-md-6 col-md-offset-3">
                        <div className="form-group">
                          <label htmlFor="FirstName" className="control-label">
                            First Name
                          </label>
                          <input
                            type="text"
                            className="form-control "
                            placeholder="Enter First Name"
                            disabled="disabled"
                            id="FirstName"
                            name="FirstName"
                            value={this.state.member_info['FirstName']}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="Surname" className="control-label">
                            Last Name
                          </label>
                          <input
                            maxLength="100"
                            type="text"
                            className="form-control "
                            placeholder="Enter Last Name"
                            disabled="disabled"
                            id="Surname"
                            name="Surname"
                            readOnly
                            value={this.state.member_info['Surname']}
                            aria-invalid="false"
                          />
                        </div>
                        <div className="form-group">
                          <label
                            htmlFor="MemberNumber"
                            className="control-label"
                          >
                            Membership Number
                          </label>
                          <input
                            maxLength="100"
                            type="text"
                            className="form-control "
                            placeholder="Enter MembershipNumber"
                            disabled="disabled"
                            id="MemberNumber"
                            name="MemberNumber"
                            readOnly
                            value={this.state.member_info['MemberNumber']}
                            aria-invalid="false"
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="Email" className="control-label">
                            Email
                          </label>
                          <input
                            maxLength="100"
                            type="text"
                            className="form-control "
                            placeholder="Enter Email"
                            disabled="disabled"
                            id="Email"
                            name="Email"
                            readOnly
                            value={this.state.member_info['Email']}
                            aria-invalid="false"
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="Address" className="control-label">
                            Address
                          </label>
                          <textarea
                            required="required"
                            className="form-control"
                            disabled="disabled"
                            value={
                              this.state.member_info['Address']
                                ? this.state.member_info['Address']
                                : 'address'
                            }
                            placeholder="Enter your address"
                            rows="4"
                            id="Address"
                            name="Address"
                            readOnly
                            aria-invalid="false"
                          >
                            {' '}
                          </textarea>
                        </div>
                        <div>
                          <button
                            className="btn btn-primary pull-right"
                            onClick={this.handleNextStep}
                          >
                            Next step <i className="fa fa-arrow-right"> </i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section
                className="step"
                style={{
                  display: this.state.currentStep === 2 ? 'block' : 'none',
                }}
              >
                <div className="panel panel-primary ">
                  <div className="panel-heading">
                    Confirm CPD Activity Details
                  </div>
                  <div className="container container-table">
                    <div
                      className="row vertical-center-row ng-invalid ng-invalid-required "
                      id="step-2"
                    >
                      <div style={{ marginTop: '40px' }}> </div>
                      <div className="col-md-6 col-md-offset-3">
                        <div className="form-group required">
                          <label
                            className="control-label"
                            htmlFor="cpd_type_id"
                          >
                            CPD Type
                          </label>
                          <select
                            disabled="disabled"
                            className="form-control"
                            name="cpd_type_id"
                            id="cpd_type_id"
                            value={this.state.cpd_type_id}
                            onChange={this.handleInputChange}
                            required=""
                            aria-invalid="true"
                          >
                            <option value="" defaultValue>
                              {' '}
                            </option>
                            {this.state.types.map((item, key) => (
                              <option key={key} value={item.CPDTypeId}>
                                {item.Description}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="form-group required" aria-hidden="true">
                          <label className="control-label" htmlFor="course_id">
                            Course Title
                          </label>
                          <div id="custom-search-input">
                            {this.state.cpd_type_id !== '4' ? (
                              <select
                                className="form-control ng-empty ng-invalid ng-invalid-required"
                                name="course_id"
                                id="course_id"
                                disabled="disabled"
                                value={this.state.course_id}
                                onChange={this.handleInputChange}
                                required=""
                                aria-invalid="true"
                                //   style={{
                                //     display:
                                //       this.state.cpd_type_id != 4
                                //         ? "block"
                                //         : "none",
                                //   }}
                              >
                                <option value="" defaultValue>
                                  {' '}
                                </option>
                                {this.state.courses.map((item, key) => (
                                  <option
                                    key={key}
                                    value={item.CourseId}
                                    label={item.CourseName}
                                  >
                                    {item.CourseName}
                                  </option>
                                ))}
                              </select>
                            ) : (
                              <input
                                type="text"
                                disabled="disabled"
                                className="form-control ng-empty ng-invalid ng-invalid-required-maxlength"
                                name="course_name"
                                id="course_name"
                                value={this.state.course_name}
                                onChange={this.handleInputChange}
                                placeholder="Course Title"
                                required=""
                                aria-invalid="true"
                                // style={{
                                //   display:
                                //     this.state.cpd_type_id === 4
                                //       ? "block"
                                //       : "none",
                                // }}
                              />
                            )}
                          </div>
                        </div>
                        <div className="form-group required">
                          <label htmlFor="cmbformat" className="control-label">
                            Format
                          </label>
                          <select
                            // disabled="disabled"
                            className="form-control"
                            name="course_format"
                            id="course_format"
                            value={this.state.course_format}
                            onChange={this.handleInputChange}
                            required=""
                            disabled={
                              this.state.cpd_type_id === '4' ? '' : 'disabled'
                            }
                            aria-invalid="true"
                          >
                            {this.state.formats.map((item, key) => (
                              <option
                                key={key}
                                value={item.ID}
                                label={item.Name}
                              >
                                {item.Name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="form-group required">
                          <label
                            className="control-label"
                            htmlFor="txtDescription"
                          >
                            Description
                          </label>
                          <textarea
                            disabled="disabled"
                            className="form-control  ng-empty ng-invalid ng-invalid-required"
                            name="course_description"
                            id="course_description"
                            value={this.state.course_description}
                            onChange={this.handleInputChange}
                            rows="4"
                            required=""
                            aria-invalid="true"
                          ></textarea>
                          <span
                            id="helpText"
                            className="small ng-hide"
                            aria-hidden="true"
                          >
                            <em>
                              Please include a full course
                              description/outline/agenda. Submission will be
                              rejected if not enough detail to approve is
                              provided.
                            </em>
                          </span>
                        </div>
                        <div className="form-group required">
                          <label
                            htmlFor="intputVenue"
                            className="control-label"
                          >
                            Venue
                          </label>
                          <input
                            type="text"
                            className="form-control ng-empty ng-invalid ng-invalid-required-maxlength"
                            name="venue"
                            id="venue"
                            disabled="disabled"
                            value={this.state.venue}
                            onChange={this.handleInputChange}
                            placeholder="Venue"
                            required=""
                            aria-invalid="true"
                          />
                        </div>
                        <div className="row">
                          <div className="form-group col-xs-4 col-md-4 required">
                            <label
                              className="control-label"
                              htmlFor="InputHour"
                            >
                              CPD Hours
                            </label>
                            <input
                              disabled="disabled"
                              type="number"
                              className="form-control ng-empty ng-invalid ng-invalid-required"
                              id="cpd_hours"
                              name="cpd_hours"
                              value={this.state.cpd_hours}
                              onChange={this.handleInputChange}
                              placeholder="Hour"
                              step="1"
                              max="100"
                              min="0"
                              required=""
                              aria-invalid="true"
                            />
                          </div>
                          <div className="form-group col-xs-4 col-md-4">
                            <label className="control-label" htmlFor="InputMin">
                              Minutes
                            </label>
                            <input
                              disabled="disabled"
                              type="number"
                              className="form-control ng-empty-step"
                              id="cpd_mins"
                              name="cpd_mins"
                              value={this.state.cpd_mins}
                              onChange={this.handleInputChange}
                              placeholder="Minute"
                              step="15"
                              max="45"
                              min="0"
                              aria-invalid="false"
                            />
                          </div>
                          <div className="form-group col-xs-4 col-md-4">
                            <label htmlFor="year" className="control-label">
                              CPD Year
                            </label>
                            <select
                              className="form-control "
                              disabled="disabled"
                              id="cpd_year"
                              name="cpd_year"
                              value={this.state.cpd_year}
                              onChange={this.handleInputChange}
                              aria-invalid="false"
                            >
                              <option label="2022" value="2022">
                                2022
                              </option>
                              <option label="2023" value="2023">
                                2023
                              </option>
                              <option label="2024" defaultValue value="2024">
                                2024
                              </option>
                              <option label="2025" value="2025">
                                2025
                              </option>
                            </select>
                          </div>
                        </div>
                        <div className="form-group required">
                          <label className="control-label">
                            Date Completed
                          </label>
                          <input
                            id="date_completed"
                            label={
                              this.state.mode === 'edit'
                                ? default_date_completed
                                : 'Enter Completed Date'
                            }
                            disabled
                            type="date"
                            name="date_completed"
                            maxDate={MAX_DATE}
                            className="form-control"
                            locales="en-GB"
                            onChange={(value) => {
                              this.handleInputChange(value, 'date_completed');
                            }}
                            value={this.state?.date_completed}
                          />
                        </div>
                        <div className="form-group required">
                          <label className="control-label">
                            Upload Evidence of Attendance
                          </label>
                          <div className="input-file ng-binding ">
                            {this.state.file_name
                              ? this.state.file_name
                              : 'Choose a file please'}
                            {/* <input
                              id="file_upload"
                              type="file"
                              placeholder="hhh"
                              disabled="disabled"
                              name="file_upload"
                              onChange={this.handleInputChange}
                              className="form-control"
                              required="required"
                              aria-invalid="true"
                            /> */}
                            {/* <button className="icon-folder"> </button> */}
                          </div>
                        </div>
                        <div>
                          <button
                            className="btn btn-default"
                            name="previous"
                            onClick={this.handlePrevStep}
                            type="button"
                          >
                            <i className="fa fa-arrow-left"> </i> Previous step
                          </button>
                          <button
                            className="btn btn-primary pull-right"
                            type="button"
                            disabled={!this.state.third_tab_active}
                            onClick={this.handleNextStep}
                          >
                            Next step <i className="fa fa-arrow-right"> </i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section
                className="step"
                style={{
                  display: this.state.currentStep === 3 ? 'block' : 'none',
                }}
              >
                <div style={{ marginTop: '60px' }} className="ng-scope">
                  {' '}
                </div>
                <div className="panel panel-primary ng-scope">
                  <div className="panel-heading">CPD Details</div>
                  <div className="container container-table">
                    <div className="row vertical-center-row" id="step-3">
                      <div style={{ marginTop: '40px' }}> </div>
                      <div className="col-md-6 col-md-offset-3">
                        <div className="form-group required">
                          <label htmlFor="host" className="control-label">
                            Host
                          </label>
                          <select
                            name="host_id"
                            id="host_id"
                            value={this.state.host_id}
                            onChange={this.handleInputChange}
                            disabled={
                              this.state.cpd_type_id === '4' ? '' : 'disabled'
                            }
                            className="form-control ng-pristine ng-untouched ng-valid ng-not-empty"
                            aria-invalid="false"
                          >
                            <option value="" defaultValue>
                              {' '}
                            </option>
                            {this.state.host_list.map((item, key) => (
                              <option key={key} value={item.ID}>
                                {item.Name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="form-group">
                          <label className="control-label">Trainer</label>
                          <input
                            maxLength="200"
                            type="text"
                            required="required"
                            id="trainer"
                            name="trainer"
                            value={this.state.trainer ? this.state.trainer : ''}
                            onChange={this.handleInputChange}
                            disabled={
                              this.state.cpd_type_id === '4' ? '' : 'disabled'
                            }
                            className="form-control ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required ng-valid-maxlength"
                            placeholder="Trainer"
                            aria-invalid="true"
                          />
                        </div>

                        <div className="form-group required">
                          <label htmlFor="location" className="control-label">
                            Location
                          </label>
                          <select
                            name="location_id"
                            id="location_id"
                            value={this.state.location_id}
                            onChange={this.handleInputChange}
                            disabled={
                              this.state.cpd_type_id === '4' ? '' : 'disabled'
                            }
                            className="form-control ng-pristine ng-untouched ng-valid ng-not-empty"
                            aria-invalid="false"
                          >
                            <option value="" defaultValue>
                              {' '}
                            </option>
                            {this.state.locations.map((item, key) => (
                              <option key={key} value={item.ID}>
                                {item.Name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="form-group required">
                          <input
                            type="checkbox"
                            name="is_declared"
                            id="is_declared"
                            disabled="disabled"
                            onChange={this.handleInputChange}
                            checked={this.state.is_declared}
                            value={this.state.is_declared}
                            // disabled={}
                            style={{ float: 'left', margin: '3px 9px 0 0' }}
                            aria-invalid="false"
                          />
                          <label
                            htmlFor="is_declared"
                            style={{ overflow: 'hidden', display: 'block' }}
                          >
                            I declare this CPD is relevant to my role and in
                            accordance with the ATI CPD Guidelines and Rules.
                          </label>
                        </div>

                        <div style={{ marginBottom: '20px' }}>
                          <button
                            className="btn btn-default"
                            name="previous"
                            onClick={this.handlePrevStep}
                            type="button"
                          >
                            <i className="fa fa-arrow-left"> </i> Previous step
                          </button>
                          <button
                            className="btn btn-success pull-right"
                            type="button"
                            disabled={
                              this.state.is_declared === true ? '' : 'disabled'
                            }
                            value={this.state.is_declared}
                            onClick={this.handleSaveRecord}
                          >
                            <i className="fa fa-floppy-o"> </i> Save{' '}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(removeData()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(FormCPD);
